import type { QueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { patchTicketCreate } from "@sd/lib/patchTicketCreate";
import { serviceDeskFormilyTicketGridQueryKey } from "@sd/services/APIs";

/** PATCH `/service_desk/ticket_create/{id}/` with `is_sla` boolean. */
export async function putTicketIsSla(
  queryClient: QueryClient,
  ticketId: string,
  isSla: boolean
): Promise<boolean> {
  try {
    const ok = await patchTicketCreate(queryClient, ticketId, {
      is_sla: isSla,
    });
    if (!ok) {
      toast.error("Failed to update SLA status");
      return false;
    }

    await queryClient.invalidateQueries({
      queryKey: serviceDeskFormilyTicketGridQueryKey,
    });

    return true;
  } catch {
    toast.error("Failed to update SLA status");
    return false;
  }
}
